import InfoRow from 'components/Info/InfoRow';
import { translate } from 'components/Translation';
import CustomInput from 'components/CustomInput/CustomInput';
import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/payments/billingAccounts/detailsStyle';
import { makeStyles } from '@material-ui/core';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IDialogBodyProps {
	billingId: string;
	value: string;
	setValue: (value: string) => void;
	label: string;
	id?: string;
}

const DialogBody = ({ billingId, value, setValue, label, id }: IDialogBodyProps) => {
	const classes = useStyles();
	return (
		<div className={classes.inputWrapper}>
			<InfoRow title={translate('payments.billingAccounts.billingAccountNumber')} value={billingId} />
			<CustomInput
				id={id}
				labelText={label}
				formControlProps={{
					fullWidth: true,
				}}
				inputProps={{
					value: value,
					onChange: (event: React.ChangeEvent<HTMLInputElement>) => setValue(event.target.value),
				}}
			/>
		</div>
	);
};

export default DialogBody;
